import {CustomModal} from "./CustomModal";

export default function ({children, isOpen, title = ''}) {
    return <CustomModal className={'w-4/5 md:w-1/3 h-fit min-h-[20%] rounded-xl border-2 text-center'} isOpen={isOpen}>
        <div className={'my-auto w-full'}>
            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 mx-auto" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor" strokeWidth="2">

                <path strokeLinecap="round" strokeLinejoin="round"
                      d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
            </svg>

            <label className={'text-3xl pb-2'}>
                {title}
            </label>
            <div className={'text-sm'}>
                {children}
            </div>
        </div>
    </CustomModal>
}